import { useLayoutEffect } from 'react';
import { warmStaticAssets } from './warmStaticAssets';

const pending=new Set();
export function useStartupPending(isPending) {
    useLayoutEffect(() => {
        if(!isPending || window.__APP_STARTUP?.finished)return undefined;
        const id=Symbol('initial-page');pending.add(id);
        return () => {pending.delete(id);};
    },[isPending]);
}
export function startupPageIsReady(root) {
    return !!root?.children.length && pending.size===0 &&
        !root.querySelector('[data-startup-pending="true"], [aria-busy="true"][aria-label="Loading page"], [data-testid="clubs-home-loading"], [data-testid="club-view-loading"]') &&
        root.textContent.trim().length>0;
}
export function visibleStartupImages(root) {
    return [...root.querySelectorAll('img')].filter(img => {
        const r=img.getBoundingClientRect();
        return r.width>0 && r.height>0 && r.bottom>0 && r.top<window.innerHeight && r.right>0 && r.left<window.innerWidth;
    }).slice(0,20);
}
export function startReadinessMonitor() {
    if(!window.__APP_STARTUP)return;
    const root=document.getElementById('root');let generation=0,stableTimer,stopped=false,preparing=false;
    const settledImage=img => new Promise(resolve => {
        if(img.complete) {Promise.resolve(img.decode?.()).catch(()=>{}).then(resolve);return;}
        const timer=setTimeout(done,7000);
        function done(){clearTimeout(timer);img.removeEventListener('load',done);img.removeEventListener('error',done);resolve();}
        img.addEventListener('load',done,{once:true});img.addEventListener('error',done,{once:true});
    });
    const check=() => {
        if(stopped || preparing || window.__APP_STARTUP.finished)return;
        clearTimeout(stableTimer);
        if(!startupPageIsReady(root))return;
        const current=++generation;
        stableTimer=setTimeout(async()=> {
            if(!startupPageIsReady(root) || current!==generation)return;
            preparing=true;
            const images=visibleStartupImages(root);
            await Promise.all(images.map(settledImage));
            if(document.fonts)await Promise.race([document.fonts.ready,new Promise(resolve=>setTimeout(resolve,3500))]);
            const cache=await warmStaticAssets(undefined,{extraUrls:images.map(img=>img.currentSrc || img.src),awaitCompletion:true});
            await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
            preparing=false;
            if(!startupPageIsReady(root) || images.map(i=>i.currentSrc || i.src).join('|') !== visibleStartupImages(root).map(i=>i.currentSrc || i.src).join('|')) {check();return;}
            observer.disconnect();clearInterval(poll);stopped=true;
            await window.__APP_STARTUP.finish(cache.status);
        },220);
    };
    const observer=new MutationObserver(check);observer.observe(root,{subtree:true,childList:true,attributes:true});
    const poll=setInterval(check,250);check();
    return ()=>{stopped=true;observer.disconnect();clearInterval(poll);clearTimeout(stableTimer);};
}
